import { render, staticRenderFns } from "./TagItemTracksView.vue?vue&type=template&id=3ba00026&"
import script from "./TagItemTracksView.vue?vue&type=script&lang=ts&"
export * from "./TagItemTracksView.vue?vue&type=script&lang=ts&"
import style0 from "./TagItemTracksView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports